import React, { Component } from 'react';

import { AppState, Actions, store, IPageState } from '../appredux'

import { connect } from 'react-redux';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { Paper, Box } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { MuiThemeProvider } from '@material-ui/core/styles';

import themeDialog from '../themes-dialog';


import DialogDelete from './dialog/Delete';
import DialogError from './dialog/Error';
import DialogOrder from './formularz/Order';
import { zbudujLiczbeLosowa, sendErrorLog } from './common/helpers';
import { fontSelect } from '../fonts';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PhotoOutlinedIcon from '@mui/icons-material/PhotoOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { AsortGrupyWiersz, AsortMenuWiersz, AsortWWWMenuNagl, Font, WWWSprzedazInfo } from '../api';
import CONFIG from '../cfg/config';
import roomImg from 'app/assets/noImage.jpg';

import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';

//PM 2021-03-11
//poprawka typow
export const AddItem = async (item: AsortGrupyWiersz, price: string = '-1') => {
  let items = store.getState().pageState.basket;

  // if (item.asort_id < 0) return;

  // if (price === '-1') {
  //   price = item.cena
  // }

  // const basketItem: ResBasketItem = {
  //   grupa_id: item.grupa_id.toString(),
  //   grupa_lp: item.grupa_lp.toString(),
  //   stawka_vat: item.vat_stawka.toString(),
  //   mag_id: item.mag_id.toString(),
  //   asort_id: item.asort_id.toString(),
  //   asort_nazwa: item.asort_nazwa.toString(),
  //   cena: price,
  //   kolejnosc: item.kolejnosc.toString(),
  // };

  //items.push(basketItem);
  items.push(item);
  await store.dispatch(Actions.pageState.updateBasket(items));
}

//PM 2021-11-03
//await


//PM 2021-11-03
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface PanelRightProps {
  page: IPageState
}

interface PanelRightState {
  openDeleteBasket: boolean,
  openDialogError: boolean,
  openDialogOrder: boolean,
  openDialogEnd: boolean,
  errorType: number,
  errorColor: number,

  basketDisplay: number
}

class PanelRight extends Component<PanelRightProps & WithStyles<typeof styles>, PanelRightState> {
  textTheme = fontSelect(this.props.page.fonts, 5, 1) as React.CSSProperties;
  contentTheme = fontSelect(this.props.page.fonts, 6, 2) as React.CSSProperties;

  constructor(props: PanelRightProps & WithStyles<typeof styles>) {
    super(props, {});

    this.state = {
      openDeleteBasket: false,
      openDialogError: false,
      openDialogOrder: false,
      openDialogEnd: false,
      errorType: 0,
      errorColor: 0,

      basketDisplay: 0
    };
  }

  toogleBasketDisplay = () => {
    this.setState({basketDisplay: this.state.basketDisplay === 0 ? 1 : 0})
  }

  //PM 2021-11-03
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  buy = (sum: number) => {
    if (this.props.page.basket.length > 0) {
      const min = this.props.page.minItems;
      if (this.props.page.basket.length < min) { //za mało
        if (sum < this.props.page.info.www_sprzedaz_kwota_limit_min) {
          this.setState({ openDialogError: true, errorType: 0, errorColor: 2 })
        } else {
          this.setState({ openDialogError: true, errorType: 0, errorColor: 1 })
        }
      } else if (this.props.page.basket.length > this.props.page.info.www_sprzedaz_ilosc_limit) { //za dużo
        if (sum > this.props.page.info.www_sprzedaz_kwota_limit_max) {
          this.setState({ openDialogError: true, errorType: 1, errorColor: 2 })
        } else {
          this.setState({ openDialogError: true, errorType: 1, errorColor: 1 })
        }
        //this.setState({  openDialogError: true, message: "Zamówienie zawiera zbyt dużo produktów.", message1: "Maksymalna ilość pozycji w koszyku:", val: this.props.page.info.www_sprzedaz_ilosc_limit})
      } else if (sum < this.props.page.info.www_sprzedaz_kwota_limit_min) { //za mała cena
        this.setState({ openDialogError: true, errorType: 0, errorColor: 0 })
        //this.setState({ openDialogError: true, message: "Kwota zamówionych produktów jest zbyt niska.", message1: "Minimalna kwota zamowienia:", val: this.props.page.info.www_sprzedaz_kwota_limit_min + ".00 zł" })  
      } else if (sum > this.props.page.info.www_sprzedaz_kwota_limit_max) { //za duża cena
        this.setState({ openDialogError: true, errorType: 1, errorColor: 0 })
        //this.setState({ openDialogError: true, message: "Kwota zamówionych produktów jest zbyt wysoka.", message1: "Maksymalna kwota zamowienia:", val: this.props.page.info.www_sprzedaz_kwota_limit_max + ".00 zł"})    
      } else {
        this.setState({ openDialogOrder: true })
      }
    }

  }

  //PM 2021-11-03 zrezygnowanie
  // basketCheck = () => {
  //   let val = 1;
  //   //let menuItems = this.props.page.menuItems;
  //   //let items = this.props.page.basket.map((e: any) => e.grupa_id)
  //   //console.log(h)
  //   this.props.basket.forEach((e) => {
  //     const h = this.props.asortHeaders.find((el) => el.grupa_id === parseInt(e.grupa_id));

  //     if (h && h.menu_id) {
  //       const m = this.props.menuItems.find((el) => el.menu_id === h.menu_id);

  //       if (m)
  //         if (m.zamowienie_min_ilosc_pozycji > val)
  //           val = m.zamowienie_min_ilosc_pozycji
  //     }
  //   });
  //   // ids.forEach((e: any) => {
  //   //   if(e == "2" || e == "13" || e == "1" || e == "7" ){
  //   //     val = true
  //   //     if(ids.includes("3") && ids.includes("15")){
  //   //       val = false
  //   //     }      
  //   //   }
  //   // });
  //   return val
  // }

  //PM 2021-11-03
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  openDeleteBasket = () => {
    if (this.props.page.basket.length !== 0)
      this.setState({ openDeleteBasket: true })
  };

  closeDialogDelete = () => {
    this.setState({ openDeleteBasket: false })
  };

  openDialogOrder = () => {
    this.setState({ openDialogError: false, openDialogOrder: true })
    sendErrorLog( "1", "1", "formularz")
    store.dispatch(Actions.pageState.addFcmLogMessage("formularz", 0))
  };

  closeDialogOrder = () => {
    this.setState({ openDialogOrder: false })
  };

  closeDialogError = () => {
    this.setState({ openDialogError: false })
  };

  //PM 2021-11-03
  DelItem = async (id: string, elNumer: number) => {
    

    let items = store.getState().pageState.basket;
  //const index = items.findIndex(item => item.asort_id.toString() === id);
  const index = elNumer;
  let item = items[elNumer]
  let prior = item.priorytet
  let nextPriorytet = item.priorytet

  let ileAsortWGrupie = 0
  let menuId = 0
  let maxDelete = 1
  //prior = 1
  //1,2,9

  let menuItem = this.props.page.asortHeaders.find(x => x.menu_id === this.props.page.selectedMenuItem)
  let grupa = this.props.page.menuItems.find(x => x.menu_id === this.props.page.selectedMenuItem)
  if(menuItem){
    menuId = menuItem.menu_id
  }
  if(grupa){
    maxDelete = grupa.zamowienie_min_ilosc_pozycji
  }
   
  if (index > -1) {
    items.splice(index, 1);
    maxDelete--;

    if(menuId === item.menu_id){//ilość w grupie
      ileAsortWGrupie++;
    }

    let rest = items.slice(elNumer)
    rest.forEach(x =>{

      if(prior < x.priorytet && maxDelete > 0){
        maxDelete--;
        prior = x.priorytet
        items.splice(index, 1);

        if(menuId === item.menu_id){//ilość w grupie
          ileAsortWGrupie++;
        }

      } else {
        prior = 999
      }
    })
  }
  // if(items[elNumer] && items[elNumer].priorytet === 2){
  //   items.splice(index, 1);
  // }
  // if(items[elNumer] && items[elNumer].priorytet === 3){
  //   items.splice(index, 1);
  // }

 
  
  //let nextPriorytet = items.length > 0 ? items[items.length -1].priorytet + 1 : 1

  if(ileAsortWGrupie !== 0){
    store.dispatch(Actions.pageState.setAsortymentowWGrupie(- ileAsortWGrupie));
  }

  //inna grupa                i   priorytet jest różny maksymalnemu
  if(menuId === item.menu_id && item.priorytet !== this.props.page.priorytetMax){
    store.dispatch(Actions.pageState.setPriorytet(nextPriorytet));
  }
  
  await store.dispatch(Actions.pageState.updateBasket(items));
  

  }

  ImgError = (source: any) => {
    source.target.src = roomImg;
    source.onerror = "";
    return true;
    }

  //PM 2021-11-03
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  //this.DelItem(...)
  render() {
    //vscTest
    //console.log('render')
    const { classes } = this.props;

    let sum: number = 0;

    for (const itm of this.props.page.basket) {
      sum = sum + parseFloat(itm.cena.replace(',', '.'));
    }

    let loop: number[] = [];
    let loopFoto: number[] = [];
    if (this.props.page.basket.length < 12) {
      for (let i = 0; i < (12 - this.props.page.basket.length); i++) {
        loop.push(i);
      }
      //for (let i = 0; i < (12 - this.props.page.basket.length * 4); i++) {
      for (let i = 0; i < (4 - this.props.page.basket.length); i++) {
        loopFoto.push(i);
      }
    }

    return (
      <Paper elevation={3} className={classes.paper}>
        <Container className={classes.header}>
          {CONFIG.kelnerBookFoto === "2" || CONFIG.kelnerBookFoto === "3" ?  <Button className={classes.foto}
            onClick={() => this.toogleBasketDisplay()}><CameraAltIcon style={{width: "18px", paddingTop: "1px", color: this.textTheme.color}}/></Button> : null }
       
          <Typography variant="h6" component="h2" color="primary" style={{...this.textTheme, display: "inline-flex"}}>
            <ShoppingCartIcon style={{paddingTop: "2px", paddingRight: "5px", margin: "auto"}}/>
            Koszyk
          </Typography>
          <Button className={classes.deleteAll}
            onClick={() => this.openDeleteBasket()}>
              {CONFIG.kelnerBookFoto === "2" || CONFIG.kelnerBookFoto === "3" ?
              <DeleteIcon style={{width: "18px", paddingTop: "1px", color: this.textTheme.color}}/> :
              <span style={{ fontSize: "14px", color: this.textTheme.color }}>-</span> }
              
              </Button>

        </Container>
        <Box>
          <Box className={classes.list} style={{padding: (CONFIG.kelnerBookFoto === "2" || CONFIG.kelnerBookFoto === "3" ) && this.state.basketDisplay === 1 ?  "10px 10% 10px 10%" : "10px 3px 10px 8px",}}>
            {this.state.basketDisplay === 0 ?
            <>
            {this.props.page.basket.map((item, index) => (
              <Box key={item.asort_id + zbudujLiczbeLosowa('0.0.0.0')} className={classes.listItem} >
                <Typography variant="subtitle2" component="span" color="primary" onClick={async () => { if(item.priorytet === this.props.page.priorytetMin || item.priorytet === this.props.page.priorytetMax ) await this.DelItem(item.asort_id.toString(), index) }} className={classes.productName} style={{...this.contentTheme, cursor: item.priorytet <= 1 ? "pointer" : "default" }}>
                  {item.asort_nazwa}
                </Typography>
                <Box component="span" style={{ flex: "1 0 30px", textAlign: "end", minWidth: "fit-content" }} >
                  <Typography variant="subtitle2" component="span" color="primary" style={{ ...this.contentTheme, paddingRight: "5px", fontWeight: "normal" }}>
                    {item.cena}
                  </Typography>
                  {
                    item.priorytet === this.props.page.priorytetMin || item.priorytet === this.props.page.priorytetMax  ?  <Button className={classes.deleteAll}
                    onClick={async () => await this.DelItem(item.asort_id.toString(), index)}><span style={{ fontSize: "14px" }}>-</span></Button>
                    : <span style={{paddingLeft: "25px"}} ></span>
                  }
                 
                </Box>
              </Box>
            ))}
            {loop.length > 0 ?
              loop.map((l) => (
                <Box key={l} className={classes.box}></Box>
              ))
              : null}

            </> : this.state.basketDisplay === 1 ? 
            <>
              {this.props.page.basket.map((item, index) => (
                <Box key={item.asort_id + zbudujLiczbeLosowa('0.0.0.0')} className={classes.listItem} >
                  <img
                          className={classes.media}
                          //style={{ boxShadow: this.props.selected ? s2 : s1 }}
                          onClick={async () => await this.DelItem(item.asort_id.toString(), index)}

                          title={item.asort_nazwa}
                          src={`https://vsc24.net/vscKelnerBook/image/${CONFIG.hotelID}/${item.asort_id}/th_foto.jpg`}
                          onError={this.ImgError}
                        />
                </Box>
                
              ))}
              {loopFoto.length > 0 ?
              loopFoto.map((l) => (
                <Box key={l} className={classes.boxFoto}></Box>
              ))
              : null}
            </> : null}

          </Box>
          <Box className={classes.summary}>
            <Typography variant="h6" component="span" color="primary" style={this.textTheme}>
              Razem:
            </Typography>
            <Typography variant="h6" component="span" color="primary" style={{ ...this.textTheme, float: "right" }}>
              {sum.toFixed(2) + ' zł'}
            </Typography>
          </Box>
        </Box>
        <Box className={classes.buy}>
          <Button
            color={'secondary'}
            variant="contained" className={classes.button}
            //disabled={this.props.page.basket.length === 0}
            onClick={() => { this.buy(sum) }}>
              
            <span style={{ fontWeight: 500, marginBottom: "2px" }}><ArrowCircleRightOutlinedIcon style={{paddingRight: "5px", marginBottom: "-6px"}}/>{"Zamów"}</span>
          </Button>
        </Box>

        <MuiThemeProvider theme={themeDialog}>
          <DialogDelete open={this.state.openDeleteBasket} close={this.closeDialogDelete} />
          <DialogError open={this.state.openDialogError} close={this.closeDialogError} openOrder={this.openDialogOrder} errorType={this.state.errorType} errorColor={this.state.errorColor} />
          {/* <DialogEnd />    */}
          <DialogOrder open={this.state.openDialogOrder} close={this.closeDialogOrder} />
        </MuiThemeProvider >
      </Paper>
    );
  }
}

const styles = (theme: Theme) => ({
  paper: {
    //padding: "10px",
    border: "1px solid #ccc",
  },
  deleteAll: {
    padding: "0",
    minWidth: "25px",
    width: "25px",
    height: "25px",
    border: "1px solid #aaa",
    //borderRadius: "0",
    float: "right" as "right"
  },
  foto: {
    padding: "0",
    minWidth: "25px",
    width: "25px",
    height: "25px",
    border: "1px solid #aaa",
    //borderRadius: "0",
    float: "left" as "left"
  },
  header: {
    textAlign: "center" as "center",
    padding: "10px 5px 8px 5px",
    borderBottom: "1px solid #ccc",
    //[theme.breakpoints.down('xs')]: {
    //  paddingRight: "40px",
    //},
  },
  list: {
    
    minHeight: "300px",
    borderBottom: "1px solid #ccc",
    [theme.breakpoints.down('xs')]: {
      paddingRight: "40px",
    },
  },
  listItem: {
    //minHeight: "25px"
    //display: "flow-root"
    display: "flex",
    alignItems: "baseline"
  },
  box: {
    height: "24px",
    borderTop: "1px solid rgba(224, 224, 224, 1)"
  },
  boxFoto: {
    //height: "70px",
    paddingTop: "66.09%",
    borderTop: "1px solid rgba(224, 224, 224, 1)"
  },
  summary: {
    padding: "5px 10px 10px",
    borderBottom: "1px solid #ccc",
    [theme.breakpoints.down('xs')]: {
      paddingRight: "50px",
    },
  },
  buy: {
    padding: "8px"
  },
  button: {
    width: "100%",
    fontSize: "20px",
    textTransform: "lowercase" as "lowercase",
    fontWeight: "bold" as "bold",
    padding: "0",
    lineHeight: "40px"
  },
  productName: {
    cursor: "pointer",
    overflow: "hidden" as "hidden",
    textOverflow: "ellipsis" as "ellipsis",
    whiteSpace: 'nowrap' as "nowrap",
    paddingRight: "10px",
    //width: "-webkit-fill-available",
  },
  media: {
    width: "calc(100% + -10px)",
    height: "auto",
    aspectRatio: "240/140",
    //maxHeight: "170px",
    //paddingTop: '56.25%', // 16:9
    margin: "1px 1px 8px 1px",
    //marginBottom: "8px",
    ////float: "left",
    border: "5px solid #fff",
    //overflow: "hidden",
    //position: "relative",
    //textAlign: "center",
    boxShadow: "2px 2px 3px 2px #e6e6e6",
    float: "left" as "left", 
    position: "relative" as "relative", 
    textAlign: "center" as "center",
    cursor: "pointer" as "pointer"
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
})

export default connect(mapStateToProps)(withStyles(styles)(PanelRight))
